import { useEffect, useMemo, useRef, useState } from 'react';
import { format } from 'date-fns';
import { DateRange, DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { es } from 'date-fns/locale';
import styles from "./datePicker.module.scss";
import { images } from '../../../../../constants/images';
import { DatePickerProps } from '../../../../../interfaces/components';

const firstDay = new Date(new Date().setDate(new Date().getDate() - 7));
const lastDay = new Date(new Date().setHours(23, 59, 59));

const DatePicker = ({
    show = false, 
    className = undefined,
    onChange = () => {}
}: DatePickerProps) => {
    const [open, setOpen] = useState(show);
    const selectLabelRef = useRef<HTMLDivElement>(null);
    const defaultSelected: DateRange = {
        from: firstDay,
        to: lastDay
    };
    const [range, setRange] = useState<DateRange | undefined>(defaultSelected);

    const onSelect = (value: any) => {
        value.from.setHours(0, 0, 0, 0);
        value.to.setHours(23, 59, 59);
        if(!!value && value?.from && value?.to) setRange(value);
    }

    const dateLabel = useMemo(() => {
        let value = "Selecciona una fecha";
        if (range?.from) {
            if (!range.to) {
                value = format(range.from, 'dd LLL, yyyy',{locale: es});
            } else if (range.to) {
                value = `${format(range.from, 'dd LLL, yyyy',{locale: es})} - ${format(range.to, 'dd LLL, yyyy',{locale: es})}`
            }
        }
        return <p className={styles.valuesSelected}>{value}</p>;
    },[range]); 

    const handleClickOutside = (event: any) => {
        if(selectLabelRef.current && !selectLabelRef.current.contains(event.target)){
            setOpen(false);
        }
    };

    useEffect(() => {
        if(onChange) onChange(range);
    },[range])

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => document.removeEventListener("click", handleClickOutside, true);
    },[])
    
   return (
    <div ref={selectLabelRef} className={`${styles.dateContainer} ${!open && styles.closedDateContainer} ${className}`}>
        <div onClick={() => setOpen(!open)} className={`${styles.selectDayPicker}`}>
            {/* TODO: Revisar esta logica de estilos ver de sacar el p del footer o sacar el div*/}
            {dateLabel}
            <img src={images.arrow} alt="calendar" className={styles.arrow} onClick={() => setOpen(!open)} />
        </div>
        <DayPicker
            id="test"
            mode="range"
            locale={es}
            className={open ? styles.datePicker : styles.datePickerDisabled}
            classNames={{caption_end: styles.rightTable, row: styles.row, button: styles.button}}
            defaultMonth={firstDay}
            modifiersStyles={{
                range_start: {backgroundColor: "#C7C7C8", fontSize: "12px", color: "#1A1C21"}, 
                range_end: {backgroundColor: "#C7C7C8", fontSize: "12px", color: "#1A1C21"}, 
                range_middle: {backgroundColor: "#C7C7C8", fontSize: "12px", color: "#1A1C21"}
            }}
            selected={range}
            footer={dateLabel}
            onSelect={onSelect}
            numberOfMonths={2} 
            pagedNavigation
        />
    </div>
   )
}

export default DatePicker;